module.exports = __webpack_public_path__ + "static/media/sdg_icon_10.d59158be.png";